import { Box, SkeletonText, SkeletonTextLine } from '@vp/swan';
import { FormattedReactMessage, __ } from '@99designs/i18n';
import { Price } from '@99designs/pricing';
import type { PriceType } from '@99designs/pricing';

interface PriceProps {
    price?: PriceType;
    loading?: boolean;
}

export function HeaderPrice({ price, loading }: PriceProps) {
    if (!price && !loading) {
        return null;
    }

    return (
        <Box data-testid="price-container" aria-live="polite" aria-busy={loading}>
            <PriceContent loading={loading} price={price} />
        </Box>
    );
}

const PriceContent = ({ loading, price }: PriceProps) => {
    if (loading) {
        return (
            <SkeletonText data-testid="skeleton-text">
                <SkeletonTextLine width="narrow" margin={{ xs: 'auto', sm: 0 }}></SkeletonTextLine>
            </SkeletonText>
        );
    }

    if (!price) {
        return null;
    }

    return (
        <FormattedReactMessage
            message={__('Custom design from <Price/>', {
                _context: 'Subtitle displaying the starting price for design services',
            })}
            replacements={{
                Price: <Price price={price} loading={false} />,
            }}
        />
    );
};
